const MAIN_REPORT_RANKING: Record<string, number> = {
  Sales_summary_report: 1,
  Sales_tax_report: 2,
  Menu_items_report: 3,
  Tips_report_title: 4,
};

function sortByRanking<T extends { title: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const rankA = MAIN_REPORT_RANKING[a.title] ?? Infinity;
    const rankB = MAIN_REPORT_RANKING[b.title] ?? Infinity;
    return rankA - rankB;
  });
}

export { MAIN_REPORT_RANKING, sortByRanking };
